import { Action } from '@ngrx/store';

export enum EExcelConnectActions {
    GetList = '[Excel connector] Get list of all connectors',
    GetListSuccess = '[Excel connector] Get list of all connectors success',
    SetViewStatus = '[Excel connector] Set view status, by default is empty'
}

export class GetList implements Action {
    public readonly type = EExcelConnectActions.GetList
}

export class GetListSuccess implements Action {
    public readonly type = EExcelConnectActions.GetListSuccess;
    constructor(public payload: IExcelConnector[]) { };
}

export class SetViewStatus implements Action {
    public readonly type = EExcelConnectActions.SetViewStatus;
    constructor(public payload: number) { };
}

export type ExcelConnectActions = GetList |
    GetListSuccess | 
    SetViewStatus;
